var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFB906"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 30,
    cy: 30,
    r: 26.25,
    fill: "#FFB906"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 22.5,
    fill: "#FFB906"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1625 19.3875L34.3625 23.7875C34.6625 24.4 35.4625 24.9875 36.1375 25.1L40.125 25.7625C42.675 26.1875 43.275 28.0375 41.4375 29.8625L38.3375 32.9625C37.8125 33.4875 37.525 34.5 37.6875 35.225L38.575 39.0625C39.275 42.1 37.6625 43.275 34.975 41.6875L31.2375 39.475C30.5625 39.075 29.45 39.075 28.7625 39.475L25.025 41.6875C22.35 43.275 20.725 42.0875 21.425 39.0625L22.3125 35.225C22.475 34.5 22.1875 33.4875 21.6625 32.9625L18.5625 29.8625C16.7375 28.0375 17.325 26.1875 19.875 25.7625L23.8625 25.1C24.525 24.9875 25.325 24.4 25.625 23.7875L27.825 19.3875C29.025 17 30.975 17 32.1625 19.3875Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.c5bacbc5907b2ea780d9e3f79b756d70.svg";
export { ForwardRef as ReactComponent };